import React, { useRef } from "react";
import { View, StyleSheet, GestureResponderEvent } from "react-native";
import { Text } from "react-native-paper";
import { useThemeSettings } from "../ThemeProvider";
import { FULL_WIDTH } from "../shared/constants/dimension";

interface Props {
    position: number;   // milliseconds
    duration: number;   // milliseconds
    onSeek: (fraction: number) => void;
}

export default function AudioProgressBar({ position, duration, onSeek }: Props) {
    const barRef = useRef<View>(null);
    const { theme } = useThemeSettings();
    const progress = duration > 0 ? Math.min(1, position / duration) : 0;

    const format = (millis: number) => {
        if (!isNaN(millis)) {
            const s = Math.floor(millis / 1000);
            const m = Math.floor(s / 60);
            const sec = s % 60;
            return `${m}:${sec < 10 ? "0" : ""}${sec}`;
        }
    };

    const onPress = (e: GestureResponderEvent) => {
        if (!barRef.current) return;

        barRef.current.measure((_x, _y, w, _h, px, _py) => {
            const touchX = e.nativeEvent.pageX - px;
            const fraction = Math.max(0, Math.min(1, touchX / w));
            onSeek(fraction);
        });
    };

    return (
        <View style={styles.row}>

            {/* PROGRESS BAR */}
            <View ref={barRef} style={styles.bar}>

                {/* Filled rounded left section */}
                <View style={[styles.fill, { flex: progress, backgroundColor: theme?.colors?.primary }]} />

                {/* Unfilled thin section */}
                <View style={[styles.remaining, { flex: 1 - progress, backgroundColor: theme?.colors?.primaryLight }]} />
            </View>
            <View style={{ flexDirection: "row", justifyContent: "space-between", width: FULL_WIDTH }}>
                {/* LEFT TIME */}
                <Text style={[styles.time, { color: theme?.colors?.primary }]}>{format(position)}</Text>
                {/* RIGHT TIME */}
                <Text style={[styles.time, { color: theme?.colors?.primary }]}>{format(duration)}</Text>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    row: {
        // flexDirection: "row",
        alignItems: "center",
        // paddingHorizontal: 24,
        width: FULL_WIDTH,
        marginTop: 8,
    },

    time: {
        fontSize: 14,
        fontWeight: "600",
        color: "#123123",
        lineHeight: 21
    },

    barWrapper: {
        flex: 1,
        paddingHorizontal: 6,
    },

    bar: {
        // flex: 1,
        height: 3,
        borderRadius: 50,
        flexDirection: "row",
        overflow: "hidden",
        alignItems: "center",
        width: FULL_WIDTH
    },

    fill: {
        height: "100%",
        borderRadius: 50,
    },

    remaining: {
        opacity: 0.3,
        height: 2,
        alignSelf: "center",
        borderRadius: 50,
    },
});